<template>
    <div id="componente-header">
        <v-card id="card-header" elevation="0">
                <p class="title-header">
                    Olá,
                    <span>
                        {{ affiliate && affiliate.register ? affiliate.register.reg_name + "!" : "Afiliado!" }}
                    </span>
                </p>
                <hr />
                <p class="description-header">Utilize os atalhos desta área para acessar facilmente as funções da Magafilio.</p>
                <div class="div-container-rotas">
                    <div class="links-first-page">
                            <div class="routes-home">
                                <router-link to="home" class="btn-home">
                                    <v-icon class="material-icons material-icons-outlined" color="orange" size="28">local_fire_department</v-icon>
                                    <p>Melhores Ofertas</p>
                                </router-link>
                            </div>
                            <div class="routes-store">
                                <router-link to="campaigns" class="btn-store">
                                    <v-icon class="material-icons" size="28">store</v-icon>
                                    <p>Anunciantes Ativos</p>
								</router-link>
							</div>
                            <div class="routes-report">
                                <router-link to="combined-report" class="btn-report">
                                    <v-icon class="material-icons" size="28" color="yellow">assessment</v-icon>
                                    <p>Performance</p>
                                </router-link>
                            </div>
							<!-- <div class="routes-dashboard">
								<router-link to="dashboard" class="btn-dashboard">
									<v-icon class="material-icons" color="yellow" size="28">leaderboard</v-icon>
									<p>Dashboard</p>
								</router-link>
							</div> -->
							<!-- <div class="routes-commission">
								<router-link to="purchases" class="btn-commission">
									<v-icon class="material-icons" color="green" size="28">paid</v-icon>
									<p>Vendas</p>
								</router-link>
							</div> -->
					</div>
					<div class="links-second-page">
							<div class="routes-link">
								<router-link to="tools" class="btn-link">
									<v-icon class="material-icons" size="28" color="blue" style="transform: rotate(-45deg)">link</v-icon>
									<p>Ferramentas de Link</p>
								</router-link>
							</div>
							<div class="routes-store">
								<router-link to="advertisers" class="btn-store">
									<v-icon class="material-icons" size="28">add_business</v-icon>
									<p>Novos Anunciantes</p>
								</router-link>
							</div>
							<div class="routes-dashboard">
								<router-link to="visits" class="btn-dashboard">
									<v-icon class="material-icons" size="28" color="yellow">visibility</v-icon>
									<p>Visitas</p>
								</router-link>
							</div>
							<div class="routes-commission">
								<router-link to="commissions" class="btn-commission">
									<v-icon class="material-icons" size="28" color="green">paid</v-icon>
									<p>Pagamentos</p>
								</router-link>
							</div>
                            <div class="routes-coupons">
                                <router-link to="coupons" class="btn-coupons">
                                    <v-icon class="material-icons" size="28" color="pink">confirmation_number</v-icon>
                                    <p>Cupons</p>
                                </router-link>
                            </div>
					</div>
				</div>
        </v-card>
    </div>
</template>

<script>
export default {
	name: 'Header',
	props: [
		'title',
	],
	computed: { 
		affiliate: {
			get() {
				return Object.keys(this.$root.affiliate).length !== 0 ? this.$root.affiliate : null
			},
			set(aff) {
				this.$root.affiliate = aff
			},
		},
	}
}
</script>

<style>

 div#componente-header {
    padding-top: 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2;
    max-width: 215px;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
 }

 #card-header {
     padding: 12px;
     background: #2D2F32; /* Fundo card (escuro) */
     box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.25) !important;
     border-radius: 0px 0px 12px 12px;
 }

 #card-header p.title-header {
     font-size: 15px;
     margin: 5px 0px;
 }

 #card-header p.title-header span {
     font-size: 18px;
     font-weight: 500;
 }

 #card-header p.description-header {
     font-size: 11px;
     opacity: 0.6;
     margin-bottom: 5px;
 }

 #card-header p {
     margin-top: 15px;
 }

 #card-header div.div-container-rotas {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }

  #card-header div.div-container-rotas a {
         text-decoration: none;
     }

#card-header div.div-container-rotas div.links-first-page div.routes-home,
#card-header div.div-container-rotas div.links-first-page div.routes-store,
#card-header div.div-container-rotas div.links-first-page div.routes-dashboard,
#card-header div.div-container-rotas div.links-first-page div.routes-report,
#card-header div.div-container-rotas div.links-first-page div.routes-commission,
#card-header div.div-container-rotas div.links-second-page div.routes-link,
#card-header div.div-container-rotas div.links-second-page div.routes-store,
#card-header div.div-container-rotas div.links-second-page div.routes-dashboard,
#card-header div.div-container-rotas div.links-second-page div.routes-commission,
#card-header div.div-container-rotas div.links-second-page div.routes-coupons {
    background: #2D2F32; 
    box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 12px;
    margin-top: 15px;
}

#card-header div.div-container-rotas div.links-first-page div.routes-home .btn-home,
#card-header div.div-container-rotas div.links-first-page div.routes-store .btn-store,
#card-header div.div-container-rotas div.links-first-page div.routes-report .btn-report,
#card-header div.div-container-rotas div.links-first-page div.routes-dashboard .btn-dashboard,
#card-header div.div-container-rotas div.links-first-page div.routes-commission .btn-commission,
#card-header div.div-container-rotas div.links-second-page div.routes-link .btn-link,
#card-header div.div-container-rotas div.links-second-page div.routes-store .btn-store,
#card-header div.div-container-rotas div.links-second-page div.routes-dashboard .btn-dashboard,
#card-header div.div-container-rotas div.links-second-page div.routes-commission .btn-commission,
#card-header div.div-container-rotas div.links-second-page div.routes-coupons .btn-coupons {
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 2px 10px;
}

#card-header div.div-container-rotas div.links-first-page div.routes-home .btn-home p,
#card-header div.div-container-rotas div.links-first-page div.routes-store .btn-store p,
#card-header div.div-container-rotas div.links-first-page div.routes-report .btn-report p,
#card-header div.div-container-rotas div.links-first-page div.routes-dashboard .btn-dashboard p,
#card-header div.div-container-rotas div.links-first-page div.routes-commission .btn-commission p,
#card-header div.div-container-rotas div.links-second-page div.routes-link .btn-link p,
#card-header div.div-container-rotas div.links-second-page div.routes-store .btn-store p,
#card-header div.div-container-rotas div.links-second-page div.routes-dashboard .btn-dashboard p,
#card-header div.div-container-rotas div.links-second-page div.routes-commission .btn-commission p,
#card-header div.div-container-rotas div.links-second-page div.routes-coupons .btn-coupons p {
    margin-left: 5px;
    font-size: 12px;
    font-weight: 500;
}

#card-header div.div-container-rotas .router-link-exact-active.router-link-active {
     box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
 }

 #card-header div.div-container-rotas .router-link-exact-active.router-link-active p {
     color: #2D2F32 !important;
 }

 #card-header div.div-container-rotas .btn-report.router-link-exact-active.router-link-active {
    background-color: #E9EC58;
 }
 #card-header div.div-container-rotas .btn-report.router-link-exact-active.router-link-active i {
    color: #2D2F32 !important;
 }

 @media (max-width: 960px) {
     div#componente-header {
         display: none;
     }
 }


 .theme--light #card-header {
     background: #FFFFFF;
     box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.1) !important;
 }

 .theme--light #card-header p.description-header {
     opacity: 0.7;
 }

.theme--light #card-header div.div-container-rotas div.links-first-page div.routes-home,
.theme--light #card-header div.div-container-rotas div.links-first-page div.routes-store,
.theme--light #card-header div.div-container-rotas div.links-first-page div.routes-report,
.theme--light #card-header div.div-container-rotas div.links-first-page div.routes-dashboard,
.theme--light #card-header div.div-container-rotas div.links-first-page div.routes-commission,
.theme--light #card-header div.div-container-rotas div.links-second-page div.routes-link,
.theme--light #card-header div.div-container-rotas div.links-second-page div.routes-store,
.theme--light #card-header div.div-container-rotas div.links-second-page div.routes-dashboard,
.theme--light #card-header div.div-container-rotas div.links-second-page div.routes-commission,
.theme--light #card-header div.div-container-rotas div.links-second-page div.routes-coupons
 {
    background: #FFFFFF; 
    box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
 }

#card-header div.div-container-rotas div.links-first-page div.routes-coupons {
    background: #2D2F32; 
    box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 12px;
    margin-top: 15px;
}

#card-header div.div-container-rotas .btn-coupons.router-link-exact-active.router-link-active {
    background-color: #F06292; /* Cor rosa para cupons */
}

#card-header div.div-container-rotas .btn-coupons.router-link-exact-active.router-link-active {
    background-color: #F06292; /* Rosa */
    border-radius: 12px;
}

#card-header div.div-container-rotas .btn-coupons.router-link-exact-active.router-link-active i,
#card-header div.div-container-rotas .btn-coupons.router-link-exact-active.router-link-active p {
    color: #2D2F32;
}
</style>